/**
 * BaseLogsClient
 * Abstract base class for all log hub clients
 * Provides common functionality for log subscription, filtering, and buffering
 */
import { BaseSignalRClient } from '../shared/BaseSignalRClient';
/**
 * Base class for log hub clients
 */
export class BaseLogsClient extends BaseSignalRClient {
    constructor(hubUrl, getToken, options = {}) {
        super(hubUrl, getToken, options);
        this.logBuffer = [];
        this.currentFilter = null;
        this.isSubscribed = false;
        this.maxBufferSize = options.maxBufferSize || 1000;
    }
    /**
     * Get current log buffer
     */
    getLogsBuffer() {
        return [...this.logBuffer];
    }
    /**
     * Get current subscription status
     */
    getIsSubscribed() {
        return this.isSubscribed;
    }
    /**
     * Get current filter
     */
    getCurrentFilter() {
        return this.currentFilter;
    }
    /**
     * Clear log buffer
     */
    clearLogs() {
        this.logBuffer = [];
    }
    /**
     * Add log to buffer with size management
     */
    addLogToBuffer(log) {
        this.logBuffer.push(log);
        // Keep only last N logs (FIFO)
        if (this.logBuffer.length > this.maxBufferSize) {
            this.logBuffer = this.logBuffer.slice(-this.maxBufferSize);
        }
    }
    /**
     * Override disconnect to cleanup subscription state
     */
    async disconnect() {
        this.isSubscribed = false;
        this.currentFilter = null;
        this.logBuffer = [];
        await super.disconnect();
    }
}
//# sourceMappingURL=BaseLogsClient.js.map